import { MenuId } from './entity'

export const Route = {
  Top: {
    path: '/',
    name: 'Top'
  },
  MenuList: {
    path: '/list',
    name: 'MenuList'
  },
  NewMenu: {
    path: '/menu/new',
    name: 'NewCook'
  },
  EditMenu: {
    path: '/menu/:menuId/edit',
    name: 'EditMenu',
    getPath: (menuId : MenuId) : string => `/menu/${menuId}/edit`
  },
  AddIngredient: {
    path: '/menu/:menuId/add-ingredient',
    name: 'AddIngredient',
    getPath: (menuId : MenuId) : string => `/menu/${menuId}/add-ingredient`
  },
  Search: {
    path: '/search',
    name: 'Search'
  },
  SearchByKeyword: {
    path: '/search/keyword',
    name: 'SearchByKeyword',
    getPath: (keyword : string) : string => `/search/keyword?key=${keyword}`
  },
  SearchByGenre: {
    path: '/search/genre',
    name: 'SearchByGenre'
  },
  SearchByMethod: {
    path: '/search/method',
    name: 'SearchByMethod'
  },
  SearchByIngredient: {
    path: '/search/ingredient',
    name: 'SearchByIngredient'
  },
  Calculation: {
    path: '/calculation',
    name: 'Calculation'
  },
  HowToUse: {
    path: '/calc/manual.html',
    name: 'HowToUse'
  },
  SearchCari: {
    path: '/search/cari',
    name: 'SearchCari'
  },
  SearchMainFood: {
    path: '/search/main_food',
    name: 'SearchMainFood'
  }
}
